/**
 * Pre-processes text before passing to ReactMarkdown.
 * - Converts ^text^ into <sup>text</sup>
 * - Fixes edge case *text** → italic text followed by a literal *
 */
export const formatMarkdown = (text) => {
  if (!text || typeof text !== 'string') return text
  return text
    .replace(/\^([^^]+)\^/g, '<sup>$1</sup>')
    .replace(/(^|[^*])\*([^*]+)\*\*(?!\*)/g, '$1*$2*\\*')
}
